<template>
  <div class="system_log">
    <!-- 面包屑 -->
    <el-form v-model="queryData">
      <el-input
        v-model.trim="queryData.model.mobile"
        style="margin: 0 0 0 10px; width: 200px"
        placeholder="手机号"
        clearable
        @clear="clear"
      />
      <el-input
        v-model.trim="queryData.model.registerIp"
        style="margin: 0 0 0 10px; width: 200px"
        placeholder="IP地址"
        clearable
        @clear="clear"
      />
      <el-select
        v-model="queryData.model.accountStatus"
        placeholder="状态"
        style="margin: 0 0 0 10px; width: 200px"
        clearable
        @clear="clear"
      >
        <el-option label="黑名单" value="0">黑名单</el-option>
        <el-option label="正常" value="1">正常</el-option>
        <!-- <el-option label="异常" value="3">异常</el-option> -->
      </el-select>
      <el-button
        class="search"
        type="primary"
        style="margin: 0 0 0 10px"
        @click="search"
        >搜索</el-button
      >
      <el-button
        class="search"
        type="primary"
        style="margin: 0 0 0 10px"
        @click="addIp"
        >添加白名单</el-button
      >
      <el-button
        class="search"
        type="primary"
        style="margin: 0 0 0 10px"
        @click="delIP"
        >删除白名单</el-button
      >
    </el-form>
    <!-- table -->
    <!-- <excel></excel> -->
    <el-table
      class="table"
      :data="tableData"
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }"
      style="width: 98.5%; margin-top: 30px; margin-left: 0px"
      highlight-current-row
      @current-change="handleCurrentChangeColor"
    >
      <el-table-column type="index" label="序号" width="130">
        <template slot-scope="scope">
          {{
            total - (queryData.pageNo - 1) * queryData.pageSize - scope.$index
          }}
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="手机号" />
      <el-table-column prop="registerIp" label="IP地址" />
      <el-table-column prop="city" label="地区" />
      <el-table-column prop="lastLoginIp" label="最后登录IP" />
      <el-table-column prop="lastLoginCountry" label="最后登录地区" />
      <el-table-column prop="lastLoginTime" label="最后登录时间" />

      <el-table-column prop="accountStatus" label="账户状态">
        <!-- 0 黑名单  1正常  3注销 -->
        <template slot-scope="scope">
          <el-tag v-if="scope.row.accountStatus == 0" type="danger"
            >黑名单</el-tag
          >
          <el-tag v-if="scope.row.accountStatus == 1" type="success"
            >正常</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.accountStatus == '1'"
            type="text"
            size="small"
            @click="LoginRecord(scope.row)"
          >
            用户登录记录
          </el-button>
          <el-button
            v-if="scope.row.accountStatus == '1'"
            type="text"
            size="small"
            @click="banUser(scope.row)"
          >
            封禁
          </el-button>
          <el-button
            v-if="scope.row.accountStatus == '0'"
            type="text"
            size="small"
            @click="banUser(scope.row)"
          >
            解封
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="blank" />
    <!-- 分页 -->
    <el-pagination
      background
      :current-page="queryData.pageNo"
      :page-sizes="[15, 30, 50, 100, 200, total]"
      :page-size="queryData.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!-- 添加白名单 -->
    <el-dialog title="添加白名单" width="30%" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="用户IP地址" label-width="100px">
          <el-input v-model="form.ip" autocomplete="off"></el-input>
        </el-form-item>
        <div class="num">用户IP只能输入一个</div>
        <el-form-item label="客服IP地址" label-width="100px">
          <el-input v-model="form.kefuip" autocomplete="off"></el-input>
        </el-form-item>
        <div class="num">客服IP间隔用英文逗号隔开</div>
        <el-form-item label="客服IP地址" label-width="100px">
          <el-tag
            v-for="(item, index) in IPlist"
            :key="item"
            closable
            @close="tagClk(item, index)"
          >
            {{ item }}
          </el-tag>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisibleClk"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 删除用户白名单 -->
    <el-dialog
      title="删除用户白名单"
      width="30%"
      :visible.sync="delDialogFormVisible"
    >
      <el-form :model="delForm">
        <el-form-item label="用户IP地址" label-width="100px">
          <el-input v-model="delForm.ip" autocomplete="off"></el-input>
        </el-form-item>
        <div class="num">用户IP只能输入一个</div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="delDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="delDialogFormVisibleClk"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 用户登录ip记录 -->
    <el-dialog
      title="用户登录ip记录"
      width="40%"
      :visible.sync="IPdialogFormVisible"
    >
      <el-table
        class="table"
        :data="userIpList"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        style="width: 98.5%; margin-top: 30px; margin-left: 0px"
        highlight-current-row
        @current-change="handleCurrentChangeColor"
      >
        <el-table-column prop="ip" label="IP地址" />
        <el-table-column prop="country" label="国家" />
        <el-table-column prop="createTime" label="登录时间" />
      </el-table>
      <el-pagination
        background
        :current-page="ipQueryData.pageNo"
        :page-sizes="[15, 30, 50, 100, 200, total]"
        :page-size="ipQueryData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="ipTotal"
        @size-change="ipHandleSizeChange"
        @current-change="ipHandleCurrentChange"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="IPdialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="IPdialogFormVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { get, post } from "@/utils/request";
// import qs from 'qs'
// import excel from "@/components/excel/excel.vue";
const moment = require("moment");
moment.locale("zh-cn");

export default {
  name: "UserManageIpCheck",
  components: {
    // excel,
  },
  data() {
    return {
      form: {
        ip: "",
        kefuip: "",
      },
      dialogFormVisible: false,
      IPdialogFormVisible: false,
      ipQueryData: {
        pageSize: 15,
        pageNo: 1,
        model: {
          userId: "",
        },
      },
      userIpList: [],
      ipTotal: 0,
      total: 0,
      queryData: {
        pageSize: 15,
        pageNo: 1,
        model: {
          phone: "",
          registerIp: "",
          accountStatus: "",
        },
      },
      created: "",
      married: "",
      tableData: [],
      currentRow: null,
      backcall: { id: "", blacklistStatus: "" },
      maildialogFormVisible: false,
      formLabelWidth: "130px",
      IPlist: [],
      delDialogFormVisible: false,
      delForm: {
        ip: "",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 删除用户白名单
    delDialogFormVisibleClk() {
      let ip = this.delForm.ip;
      this.delDialogFormVisible = false;
      post("/admin/sysconfig/deleteWhiteIp", { ip }).then((res) => {
        if (res.data.code == "20000") {
          this.$message({
            message: res.data.message,
            type: "success",
          });
          this.getList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 删除客服ip列表
    tagClk(item, index) {
      this.IPlist.splice(index, 1);
      let ip = item;
      post("/admin/employee/deleteWhiteIp", { ip }).then((res) => {
        if (res.data.code == "20000") {
          this.getKefuList();
        }
      });
    },
    // 用户登录记录
    LoginRecord(row) {
      // console.log(row);
      this.ipQueryData.model.userId = row.id;
      this.IPdialogFormVisible = true;
      this.uesrLoginRecord();
    },
    // 获取客服ip列表
    getKefuList() {
      post("/admin/employee/queryWhiteIp").then((res) => {
        this.IPlist = res.data.data;
      });
    },
    // 获取用户登录ip的记录
    uesrLoginRecord() {
      post("/admin/userLoginRecord/page", this.ipQueryData).then((res) => {
        this.userIpList = res.data.data.data;
        this.ipTotal = res.data.data.total;
      });
    },
    // 添加白名单
    dialogFormVisibleClk() {
      this.dialogFormVisible = false;
      if (!this.form.ip && !this.form.kefuip) {
        this.$message.error("不能输入空值！");
        return;
      }
      if (this.form.ip) {
        let ip = this.form.ip;
        post("/admin/sysconfig/addWhiteIp", { ip }).then((res) => {
          if (res.data.code == "20000") {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getList();
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        let ip = this.form.kefuip;
        post("/admin/employee/addWhiteIp", { ip }).then((res) => {
          if (res.data.code == "20000") {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getList();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    // 添加ip
    addIp() {
      this.dialogFormVisible = true;
      this.form = {};
      this.getKefuList();
    },
    // 删除ip
    delIP() {
      this.delDialogFormVisible = true;
      this.delForm = {};
    },
    clear() {
      this.getList();
    },

    // 拉黑/洗白
    banUser(row) {
      const userId = row.id;
      // console.log(row);
      const message = row.accountStatus == "1" ? "解封此用户" : "封禁此用户";
      this.$confirm(message + "," + "是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let accountStatus;
          if (row.accountStatus == "1") {
            accountStatus = "WHITE";
          } else {
            accountStatus = "BLACK";
          }
          post("/admin/app/user/account/status/update", {
            accountStatus,
            userId,
          }).then((res) => {
            // console.log(res);
            if (res.data.message == 200) {
              this.$message({
                message: res.data.message,
                type: "success",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    ipHandleSizeChange(val) {
      this.ipQueryData.pageSize = val;
      this.uesrLoginRecord();
    },
    ipHandleCurrentChange(val) {
      this.ipQueryData.pageNo = val;
      this.uesrLoginRecord();
    },
    handleCurrentChangeColor(val) {
      this.currentRow = val;
    },
    handleSizeChange(val) {
      this.queryData.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryData.pageNo = val;
      this.getList();
    },
    search() {
      this.queryData.pageNo = 1;
      this.$nextTick(() => {});
      post("/admin/app/user/ip", this.queryData).then((res) => {
        this.tableData = res.data.data.data;
        this.total = res.data.data.total;
        this.page = res.data.data.total;
        this.$message.success("搜索成功");
      });
    },
    getList() {
      post("/admin/app/user/ip", this.queryData).then((res) => {
        this.total = res.data.data.total;
        this.tableData = res.data.data.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.num {
  padding-left: 100px;
  margin-bottom: 20px;
  color: #f76500;
}
.el-tag {
  margin-right: 5px;
}
</style>
